import { Component, Vue } from 'vue-property-decorator';

import user_module from '@/modules/user';

import { GroupUser } from '@/modules/user/index.d';

import DropdownClick from '@/components/dropdown/DropdownClick.vue';
import 'vue-toasted';

interface DropDownUser {
  short?: string;
  id: number;
}

@Component({
  components: {
    DropdownClick,
  },
})
export default class GroupUsers extends Vue {
  usersArray: GroupUser[] = [];
  selectedUserId: number | null = null;
  isLoading: boolean = true;

  formUserString(user: GroupUser) {
    return `${user.Login} - ${user.FName} ${user.LName}`;
  }

  get formattedUsers() {
    console.log(this.usersArray.map(user => user.ID).sort());
    
    return this.usersArray.map((user: GroupUser) => ({
      short: this.formUserString(user),
      id: user.ID,
    }));
  }

  get selectedUserById() {
    const { selectedUserId, formUserString } = this;

    if (!selectedUserId) return 'Myself';

    const selectedUser = this.usersArray.find(
      (user: GroupUser) => user.ID === selectedUserId,
    );

    return formUserString(selectedUser);
  }

  created() {
    user_module.getMyGroupUsers().then((usersFromServer: GroupUser[]) => {
      this.usersArray = [...usersFromServer];
      this.selectedUserId = Number(localStorage.getItem(`groupUserId:${user_module.login}`)) || null;
      this.isLoading = false;

      if (this.selectedUserId)
        return this.selectUser({ id: this.selectedUserId });
    });
  }

  selectUser(item: DropDownUser) {
    this.isLoading = true;

    const userInfo = this.usersArray.find((user) => user.ID === item.id);

    let postMessageInfo = null;

    user_module
      .getGroupUserTokenFromApi(item.id)
      .then((data: any) => {
        if (data.error) {
          this.isLoading = false;

          return this.$toasted.error(
            `<b>Unable to retrieve user info. Try again later.</b>`,
          );
        }

        localStorage.setItem(`groupUserId:${user_module.login}`, item.id.toString());
        this.selectedUserId = item.id;

        return data?.Token;
      })
      .then((token) =>
        user_module.getGroupLogin({
          login: userInfo.Login,
          Token: token,
        }),
      )
      .then((msg) => (msg ? (postMessageInfo = { ...msg }) : null))
      .then(() => user_module.setFirstIframe(true))
      .then(() => {
        this.isLoading = false;

        const rootIframe: any = document.getElementById('firstIframe');

        if (!postMessageInfo) {
          return this.$toasted.error(
            `<b>Unable to retrieve user credentials. Please, try again later.</b>`,
          );
        }

        if (rootIframe) {
          console.log('Info', rootIframe, postMessageInfo);

          rootIframe.contentWindow.postMessage(postMessageInfo, '*');
          window.addEventListener('message', this.turnOffIframe);
        }
      })
  }

  removeSelectedUser() {
    user_module.removeActiveGroupUserToken();

    this.selectedUserId = null;
    localStorage.removeItem(`groupUserId:${user_module.login}`);

    Promise.resolve(() => user_module.setFirstIframe(true))
      .then(() => {
        const rootIframe = document.getElementById('firstIframe');

        const defaultMessage = {
          token: user_module.token,
          fingerPrint: user_module.fingerPrint,
          login: user_module.login,
          password: user_module.password,
          rawPassword: user_module.rawPassword,
          appstore: true,
          userInfo: user_module.userInfo,
        };

        (<HTMLIFrameElement>rootIframe).contentWindow.postMessage(
          defaultMessage,
          '*',
        );

        window.addEventListener('message', this.turnOffIframe);
      });
  }

  turnOffIframe(message: any) {
    if (message.data?.hideFirst) {
      user_module.setFirstIframe(false);
    }

    window.removeEventListener('message', this.turnOffIframe);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.turnOffIframe);
  }
}
